import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-6 py-24" data-id="element-80">
      {/* Background subtle glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,160,23,0.08)_0%,transparent_50%)]" data-id="element-81" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-83">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-84">
            GENERACIÓN WEALTH: <br className="hidden md:block" data-id="element-85" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-86">
              Tu Primer Dinero (Sin Errores)
            </span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-87">
          <p className="text-lg md:text-2xl text-gray-400 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-88">
            El sistema de blindaje financiero para jóvenes latinos en USA que
            quieren construir riqueza real sin repetir los errores de sus
            padres.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-89">
          <button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-gold-500 text-dark font-bold text-lg rounded-full overflow-hidden transition-transform hover:scale-105 hover:shadow-[0_0_30px_rgba(212,160,23,0.4)]" data-id="element-90">
            <span className="relative z-10 flex items-center gap-2" data-id="element-91">
              ACCEDER AL SISTEMA AHORA
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-92" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-93" />
          </button>
        </motion.div>
      </div>
    </section>;
}